<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Diagnostic Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      
      @if (showDiagLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- View when both forms and accounts exist -->
      @if (formData.length > 0 && accountData.length > 0) {
<div class="PC_SCHD_A_Diag">
        <div class="col-md-7 diag-blocks">
          <div class="slim-scroll-block">
            <table class="main_table">
              <thead>
                <tr>
                  <th colspan="3">
                    <span class="schd-name">Forms</span>
                  </th>
                  <th colspan="3">
                    <div class="legend_block">
                      <span class="legend_mul"></span>
                      <span>Multiplier</span>
                      <span class="legend_amt"></span>
                      <span>Amount</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: center;width: 42px;">
                    <span>#</span>
                  </th>
                  <th colspan="3">
                    <span>Forms Description</span>
                  </th>
                  <th colspan="2" class="subHeader">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- 1st Level Drilldown -->
                @for (row of formData; track $index; let i = $index) {
<tr>
                  <td colspan="1" style="vertical-align: top;">{{row.LINE_NO}}</td>
                  <td colspan="3">
                    <span style="cursor: pointer;" (click)="getAccts('main', row.toggleTotal || false, 0, row.ACCT, i, '')">
                      <i class="fa" [ngClass]="row.toggleTotal ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                    </span> &nbsp; {{row.DESCRIPTION}}
                    
                    <!-- 2nd Level Drilldown -->
                    @if (row.toggleTotal) {
<div class="totalLines">
                      @if (row.main_loader) {
<div class="viewFormLoader">
                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                      </div>
}
                      <table>
                        @for (total of totalLines; track $index; let j = $index) {
<tr>
                          <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                          <td>
                            <div style="display: flex;">
                              <span style="cursor: pointer;" (click)="getAccts('main_sub', total.toggle || false, 0, total.ACCT, j, '')">
                                @if (show_toggle_total) {
<i class="fa" [ngClass]="total.toggle ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
}
                              </span>&nbsp;
                              <span>{{total.DESCRIPTION}}</span>
                            </div>
                            
                            <!-- 3rd Level Drilldown -->
                            @if (total.toggle) {
<div class="childAcctBlock">
                              @if (total.main_sub_loader) {
<div class="viewFormLoader">
                                <i class="fa fa-spinner fa-spin gt-refresh"></i>
                              </div>
}
                              <table>
                                @for (lines of main_sub_data; track $index; let k = $index) {
<tr>
                                  <td style="vertical-align: top;">{{lines.LINE_NO}}</td>
                                  <td>
                                    <span style="cursor: pointer;" (click)="getAccts('accounts', lines.toggle || false, 0, lines.ACCT, k, '')">
                                      @if (show_toggle) {
<i class="fa" [ngClass]="lines.toggle ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
}
                                    </span>&nbsp;
                                    <span>{{lines.DESCRIPTION}}</span>
                                    
                                    <!-- 4th Level Drilldown -->
                                    @if (lines.toggle) {
<div class="childAcctBlock" style="background: lightyellow;">
                                      @if (lines.child_loader) {
<div class="viewFormLoader">
                                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                      </div>
}
                                      <table>
                                        @for (acct of acct_data; track $index) {
<tr>
                                          <td style="vertical-align: top;">{{acct.LINE_NO}}</td>
                                          <td><span>{{acct.DESCRIPTION}}</span></td>
                                          <td><span style="background: gray;" class="amountBadge">{{acct.MULTIPLIER}}</span></td>
                                          <td><span class="amountBadge">{{acct.AMOUNT}}</span></td>
                                        </tr>
}
                                      </table>
                                    </div>
}
                                  </td>
                                  <td style="vertical-align: top;"><span style="background: gray;" class="amountBadge">{{lines.MULTIPLIER}}</span></td>
                                  <td style="vertical-align: top;"><span class="amountBadge">{{lines.AMOUNT}}</span></td>
                                </tr>
}
                              </table>
                              @if (no_main_sub_data) {
<div class="no_records">No Mappings Found</div>
}
                            </div>
}
                          </td>
                          <td style="text-align: right;vertical-align: top;">
                            <span style="background: gray;" class="amountBadge">{{total.MULTIPLIER}}</span>
                          </td>
                          <td style="text-align: right;vertical-align: top;">
                            <span class="amountBadge">{{total.AMOUNT}}</span>
                          </td>
                        </tr>
}
                      </table>
                    </div>
}
                  </td>
                  <td colspan="2" style="text-align: right;vertical-align: top;">
                    <span class="amountBadge">{{row.AMOUNT}}</span>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
        
        <div class="col-md-5 diag-blocks">
          <div class="slim-scroll-block">
            <table class="main_table">
              <thead>
                <tr>
                  <th colspan="4">
                    <span class="schd-name">Accounts</span>
                  </th>
                  <th colspan="4"></th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: left;width: 64px;">
                    <span>#</span>
                  </th>
                  <th colspan="6">
                    <span>Accounts Description</span>
                  </th>
                  <th colspan="1" class="subHeader">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (row of accountData; track $index; let i = $index) {
<tr>
                  <td colspan="1" style="text-align: left;width: 64px;vertical-align: top;">{{i+1}}</td>
                  <td colspan="6">
                    <span style="cursor: pointer;" (click)="getAccts('main_acct', row.toggle || false, 0, row.ACCT, i, '')">
                      <i class="fa" [ngClass]="row.toggle ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                    </span> &nbsp; {{row.DESCRIPTION}}
                    
                    <!-- 1st level drilldown (main_acct) -->
                    @if (row.toggle) {
<div class="totalLines">
                      @if (row.main_loader) {
<div class="viewFormLoader">
                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                      </div>
}
                      <table>
                        @for (total of acctChild; track $index) {
<tr>
                          <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                          <td>
                            <span style="cursor: pointer;">
                              &nbsp;<span>{{total.DESCRIPTION}}</span>
                            </span>
                          </td>
                        </tr>
}
                      </table>
                      @if (no_acct_child) {
<div style="padding: 0px 0px 8px 18px;">No Mappings Found</div>
}
                    </div>
}
                  </td>
                  <td colspan="1" style="text-align: right;vertical-align: top;">
                    <span class="amountBadge">{{row.AMOUNT}}</span>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      <!-- View when only forms exist -->
      @if (formData.length > 0 && accountData.length == 0) {
<div class="PC_SCHD_A_Diag">
        <div class="col-md-12 diag-blocks">
          <div class="slim-scroll-block">
            <table class="main_table">
              <thead>
                <tr>
                  <th colspan="3">
                    <span class="schd-name">Forms</span>
                  </th>
                  <th colspan="3">
                    <div class="legend_block">
                      <span class="legend_mul"></span>
                      <span>Multiplier</span>
                      <span class="legend_amt"></span>
                      <span>Amount</span>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th colspan="1" style="text-align: center;width: 42px;">
                    <span>#</span>
                  </th>
                  <th colspan="3">
                    <span>Forms Description</span>
                  </th>
                  <th colspan="2" class="subHeader">
                    <span>Amount</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (row of formData; track $index; let i = $index) {
<tr>
                  <td colspan="1" style="vertical-align: top;">{{row.LINE_NO}}</td>
                  <td colspan="3">
                    <span style="cursor: pointer;" (click)="getAccts('main', row.toggleTotal || false, 0, row.ACCT, i, '')">
                      <i class="fa" [ngClass]="row.toggleTotal ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                    </span> &nbsp; {{row.DESCRIPTION}}
                    
                    <!-- Nested structure same as above -->
                    @if (row.toggleTotal) {
<div class="totalLines">
                      @if (row.main_loader) {
<div class="viewFormLoader">
                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                      </div>
}
                      <table>
                        @for (total of totalLines; track $index; let j = $index) {
<tr>
                          <td style="vertical-align: top;">{{total.LINE_NO}}</td>
                          <td>
                            <span style="cursor: pointer;" (click)="getAccts('main_sub', total.toggle || false, 0, total.ACCT, j, '')">
                              @if (show_toggle_total) {
<i class="fa" [ngClass]="total.toggle ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
}
                            </span>&nbsp;
                            <span>{{total.DESCRIPTION}}</span>
                            
                            @if (total.toggle) {
<div class="childAcctBlock">
                              @if (total.main_sub_loader) {
<div class="viewFormLoader">
                                <i class="fa fa-spinner fa-spin gt-refresh"></i>
                              </div>
}
                              <table>
                                @for (lines of main_sub_data; track $index; let k = $index) {
<tr>
                                  <td style="vertical-align: top;">{{lines.LINE_NO}}</td>
                                  <td>
                                    <span style="cursor: pointer;" (click)="getAccts('accounts', lines.toggle || false, 0, lines.ACCT, k, '')">
                                      @if (show_toggle) {
<i class="fa" [ngClass]="lines.toggle ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
}
                                    </span>&nbsp;
                                    <span>{{lines.DESCRIPTION}}</span>
                                    
                                    @if (lines.toggle) {
<div class="childAcctBlock" style="background: lightyellow;">
                                      @if (lines.child_loader) {
<div class="viewFormLoader">
                                        <i class="fa fa-spinner fa-spin gt-refresh"></i>
                                      </div>
}
                                      <table>
                                        @for (acct of acct_data; track $index) {
<tr>
                                          <td style="vertical-align: top;">{{acct.LINE_NO}}</td>
                                          <td><span>{{acct.DESCRIPTION}}</span></td>
                                          <td><span style="background: gray;" class="amountBadge">{{acct.MULTIPLIER}}</span></td>
                                          <td><span class="amountBadge">{{acct.AMOUNT}}</span></td>
                                        </tr>
}
                                      </table>
                                    </div>
}
                                  </td>
                                  <td style="vertical-align: top;"><span style="background: gray;" class="amountBadge">{{lines.MULTIPLIER}}</span></td>
                                  <td style="vertical-align: top;"><span class="amountBadge">{{lines.AMOUNT}}</span></td>
                                </tr>
}
                              </table>
                              @if (no_main_sub_data) {
<div style="padding: 0px 0px 8px 18px;">No Mappings Found</div>
}
                            </div>
}
                          </td>
                          <td style="text-align: right;vertical-align: top;">
                            <span style="background: gray;" class="amountBadge">{{total.MULTIPLIER}}</span>
                          </td>
                          <td style="text-align: right;vertical-align: top;">
                            <span class="amountBadge">{{total.AMOUNT}}</span>
                          </td>
                        </tr>
}
                      </table>
                      @if (no_total_lines) {
<div style="padding: 0px 0px 8px 18px;">No Mappings Found</div>
}
                    </div>
}
                  </td>
                  <td colspan="2" style="text-align: right;vertical-align: top;">
                    <span class="amountBadge">{{row.AMOUNT}}</span>
                  </td>
                </tr>
}
              </tbody>
            </table>
          </div>
        </div>
      </div>
}

      <!-- View when no data -->
      @if (!showDiagLoader && formData.length == 0 && accountData.length == 0) {
<div class="PC_SCHD_A_Diag">
        <div class="col-md-12 diag-blocks">
          <div class="block" style="height:50px;">
            <table>
              <thead>
                <tr>
                  <th colspan="12"><span>Whitepaper info unavailable.</span></th>
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </div>
}

    </div>
}

    <!-- Form View Tab -->
    @if (activeTab === 2) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      
      @if (showFormLoader) {
<div class="viewFormLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}
      
      <div class="PC_SCHD_C">
        @if (scheduleCFormView.rows.length > 0) {
<table>
          <thead>
            <tr>
              <th colspan="7">
                <span class="schd-name">Schedule C</span>
                <span class="schd-desc">Dividends, Inclusions, Dividends-Received Deduction, and Other Special Deductions</span>
                <span class="schd-ins">(see instructions)</span>
              </th>
            </tr>
            <tr>
              <th colspan="2" rowspan="2" style="text-align: center;">
                <span>Income</span>
              </th>
              <th colspan="2" class="subHeader">
                <span class="schd-sub">Dividends and Inclusions</span>
              </th>
              <th colspan="1" rowspan="2" class="subHeader">
                <span class="schd-sub">(c) %</span>
              </th>
              <th colspan="2" class="subHeader">
                <span class="schd-sub">Dividends-Received and Other Special Deductions</span>
              </th>
            </tr>
            <tr>
              <th colspan="1" class="subHeader">
                <span>(a) Subject to section 832(b)(5)(B)</span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(b) Dividends and inclusions</span>
              </th>
              <th colspan="1" class="subHeader">
                <span class="schd-sub">(a) Subject to section 832(b)(5)(B)</span>
              </th>
              <th colspan="1" class="subHeader">
                <span>(b) Total dividends-received and special deductions</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (row of scheduleCFormView.rows; track $index) {
<tr>
              <td>{{row.num}}</td>
              <td>{{row.description}}</td>
              <td>
                @if (!isDisabledForValue1(row.num)) {
<div class="input_enabled">{{formatNumber(row.value1)}}</div>
}
                @if (isDisabledForValue1(row.num)) {
<input class="input_disabled" disabled>
}
              </td>
              <td>
                @if (!isDisabledForValue2(row.num)) {
<div class="input_enabled">{{formatNumber(row.value2)}}</div>
}
                @if (isDisabledForValue2(row.num)) {
<input class="input_disabled" disabled>
}
              </td>
              <td style="width: 80px;text-align: center;font-weight: bold;vertical-align: middle;" align="right">
                @if (!isPercentHidden(row.num)) {
<div>
                  <span>{{row.percent}}</span>
                </div>
}
                @if (isPercentHidden(row.num)) {
<div class="input_disabled"></div>
}
              </td>
              <td>
                @if (!isValue3Hidden(row.num)) {
<div class="input_enabled">{{formatNumber(row.value3)}}</div>
}
              </td>
              <td>
                @if (!isValue4Hidden(row.num)) {
<div class="input_enabled">{{formatNumber(row.value4)}}</div>
}
              </td>
            </tr>
}
          </tbody>
        </table>
}
      </div>

    </div>
}
  </div>
</div>

